import { Expose, Type } from 'class-transformer';
import { isEmpty } from 'lodash';
import { TransformDate } from 'src/app/common/util/transform-date';
import { DeviceStatus } from './device-status';
import { DeviceType } from './device-type';
import { Vehicle } from './vehicle';

export class Device {
  devId: number;
  id: string;
  deviceType: DeviceType;
  constantLocation: boolean;
  @Expose({ name: 'machineid' })
  machineId: string;
  @Type(() => Vehicle)
  vehicle: Vehicle;
  deviceModel: string;
  role: string;
  status: DeviceStatus;

  getDeviceIP(): string | null {
    const input = this.id;
    if (isEmpty(input))
      return null;
    const ipv4Regex = /(\d{1,3}\.){3}\d{1,3}/;
    const ipv4Match = ipv4Regex.exec(input);

    if (ipv4Match) {
      const ip = ipv4Match[0];
      // Opcjonalna walidacja: czy liczby nie przekraczają 255
      const parts = ip.split('.');
      const isValid = parts.every(part => {
        const num = parseInt(part, 10);
        return num >= 0 && num <= 255;
      });
      return isValid ? ip : null;
    }

    // 2. Jeśli nie ma IPv4, sprawdzamy czy to czyste IPv6
    // Bardzo uproszczony regex dla IPv6 (szuka bloków hex oddzielonych dwukropkami)
    const ipv6Regex = /(([0-9a-fA-F]{1,4}:){1,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|:(:[0-9a-fA-F]{1,4}){1,7})/;
    const ipv6Match = ipv6Regex.exec(input);

    if (ipv6Match) {
      return ipv6Match[0];
    }
    return null;
  }

}

export class DeviceSoftwareLog {
  id: number;
  log: any;
  @TransformDate()
  receiveDate: Date;
}

